var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrianglebg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 104,
    viewBox: "0 0 99 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.5574 0.0627236L0.0709841 103.363V11.6066C-0.502725 2.05451 6.34562 -0.33342 10.3966 0.0622459L98.5574 0.0627236Z",
    fill: "#EAF1FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrianglebg);
export default __webpack_public_path__ + "static/media/trianglebg.9fa8bd5bf13f93b7d8325d67bdafe8d9.svg";
export { ForwardRef as ReactComponent };